import React, { useEffect } from "react";
import axios from "axios";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link } from "react-router-dom";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useState } from "react";
import url from "../../serverurl";
import { blockValue, getBLockNumber, getBlockSize } from "../../utils";

const columns = [
  { id: "Block", label: "BLOCK HEIGHT" },
  { id: "NunmberTXN", label: "TXNS" },
  { id: "ID", label: "SIZE" },
  { id: "Txn", label: "HASH" },
  { id: "Age", label: "TIMESTAMP" },
  { id: "Used", label: "VALUE" },
  { id: "Limit", label: "PREVIOUS HASH" },
  { id: "Reward", label: "NODE" },
  { id: "Burnt", label: "ORIGINATION" },
  { id: "Fee", label: "STATUS", minWidth: 120 },
];

function Newblock() {
  // ===== STATE — IDENTICAL =====
  const [pecuscanData, setpecuscanData] = useState([]);
  const [blockPage, setBlockPage] = React.useState(10);
  const [pageIndex, setPageIndex] = React.useState(0);
  const [PreviousPage, setPreviousPage] = React.useState(true);
  const [nextPage, setNextPage] = React.useState(false);

  // ===== HANDLERS — IDENTICAL =====
  const handleChange = (event) => {
    setBlockPage(event.target.value);
  };
  const handleNext = (event) => {
    setPageIndex(pageIndex + 1);
  };
  const handleLastPage = (event) => {
    setPageIndex(Math?.ceil(pecuscanData.totalPages - 1));
  };
  const handlePrevious = (event) => {
    setPageIndex(pageIndex - 1);
  };
  const handleFirstPage = (event) => {
    setPageIndex(Math?.ceil(pecuscanData.totalPages - 2));
  };

  // ===== API — IDENTICAL =====
  const transactionsEscrow = () => {
    const body = {
      minLimit: 10,
    };
    axios
      .get(`${url}/blockchain/blocks?page=${pageIndex}&pageSize=${blockPage}`)
      .then((res) => {
        setpecuscanData(res.data);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    transactionsEscrow();
  }, [])
  useEffect(() => {
    transactionsEscrow();
  }, [pageIndex, blockPage])

  return (
    <section className="container" style={{ padding: "0" }}>
      <div className="term-allblock-wrap">
        <div className="term-allblock-card">

          {/* Header */}
          <div className="term-allblock-head">
            <div>
              <span className="term-panel-title">▸ ALL BLOCKS</span>
              <div className="term-allblock-sub">
                Total of {getBLockNumber(pecuscanData?.totalPages * blockPage) || 0} blocks
              </div>
            </div>
            <span className="term-status">
              <span className="term-dot"></span>LIVE
            </span>
          </div>

          {/* Table */}
          <div className="term-table-wrap">
            <table className="term-table">
              <thead>
                <tr>
                  {columns.map((column) => (
                    <th
                      key={column.id}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {pecuscanData?.blocks
                  ?.slice(0, blockPage)
                  .map((data, idx) => (
                    <tr key={idx}>
                      <td>
                        <Link to={`/block/${data.hash}`} state={data} className="term-table-link">
                          {getBLockNumber(data.index)}
                        </Link>
                      </td>
                      <td>{data.data.length}</td>
                      <td className="term-table-mute">{getBlockSize(data)}</td>
                      <td>
                        <span className="term-table-hash">{data.hash}</span>
                      </td>
                      <td className="term-table-mute">{new Date(data.timestamp).toUTCString()}</td>
                      <td className="term-table-amount">{blockValue(data.data)} USD</td>
                      <td>
                        <span className="term-table-hash">{data.previousHash}</span>
                      </td>
                      <td className="term-table-mute">{data.node}</td>
                      <td className="term-table-mute">{data.origin}</td>
                      <td>
                        {data?.status ? (
                          <span className="failButton">
                            <i><CancelIcon /></i>
                            Fail
                          </span>
                        ) : (
                          <span className="successButton">
                            <i><CheckCircleIcon /></i>
                            Success
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="term-pagination">
            <div className="term-pagination-left">
              <span>SHOW:</span>
              <select
                value={blockPage}
                onChange={handleChange}
                className="term-page-select"
              >
                {[10, 25, 50, 100].map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            </div>
            <div className="term-pagination-right">
              <button
                className="term-page-btn"
                onClick={handleFirstPage}
                disabled={pageIndex === 0}
              >
                FIRST
              </button>
              <button
                className="term-page-btn term-page-btn-icon"
                onClick={handlePrevious}
                disabled={pageIndex === 0}
              >
                <ArrowBackIosNewIcon sx={{ fontSize: 12 }} />
              </button>
              <span className="term-page-current">
                PAGE {pageIndex + 1}
              </span>
              <button
                className="term-page-btn term-page-btn-icon"
                onClick={handleNext}
              >
                <ArrowForwardIosIcon sx={{ fontSize: 12 }} />
              </button>
              <button
                className="term-page-btn"
                onClick={handleLastPage}
                disabled={pageIndex === 0 ? nextPage : !nextPage}
              >
                LAST
              </button>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Newblock;